import { http } from '../../../axios';
import { localContentPrefix } from '../../../../config';
import { AgeCategory } from '../../../../../models/AgeCategory';
import { Level1Out } from '../../../../store/apiLibx';

export function fetchLocalRegions(ageCategory: AgeCategory, shopLanguage: string | undefined) {
    return http
        .get<{ level1: Level1Out[] }>(`${localContentPrefix}/v1/marketplace/localregions`, {
            params: {
                ageCategory: ageCategory !== AgeCategory.ALL_AGES ? ageCategory : undefined,
                shopLanguage
            }
        })
        .then(response => response.data);
}
